import { useCallback } from "react";

/**
 * A hook that provides functionality related to rate revisions.
 */
export const useRateRevision = () => {
  const getRevisionNumber = useCallback((revisions: number) => `v${revisions}`, []);
  return { getRevisionNumber };
};
